import { gql } from '@apollo/client'
import React from 'react'

import { formsClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormState = () => React.useContext(Context)
export const useForm = () => useFormState()?.form

const QUERY = gql`
  query Form($id: ID) {
    form(id: $id) {
      id
      name
      repliesCount
    }
  }
`

const FormLoader = ({ id, children }) => {
  const { formId } = useModalData() || {}
  id = id || formId

  const { data, ...state } = useQuery(QUERY, {
    variables: { id },
    client: formsClient,
    fetchPolicy: 'cache-first'
  })

  return (
    <Provider value={data}>
      <StatePresenter {...state}>{children}</StatePresenter>
    </Provider>
  )
}

export default FormLoader
